import { render, staticRenderFns } from "./editIosTier.vue?vue&type=template&id=32d07868&"
import script from "./editIosTier.vue?vue&type=script&lang=js&"
export * from "./editIosTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports